<template>
  <div class="container">

    <!-- Loading加载 -->
    <div class="loading" v-if="isDetail">
      <van-loading size="40px" type="spinner" color="#39CCCD" vertical>
        <div class="loading-text">
          <div>页面正在加载</div>
          <div>请稍候</div>
        </div>
      </van-loading>
    </div>

    <!-- 详情 -->
    <div class="content" v-html="detail.detail" v-show="!isDetail" @click="handleEnroll">
    </div>
    <div class="footer-fit" v-if="detail.id && status !== 1 && !isDetail">
      <div class="bottom">
        <div class="left">限时仅需：￥<span class="left-qian">{{ detail.price }}</span></div>
        <div class="right">
          <div class="btn" @click.stop="handleEnroll">
            <!-- <div class="grab">前200名限时秒抢</div> -->
            <div class="grab">抓紧抢购</div>
            <div class="enroll">马上报名</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情回显 -->
    <div class="footer-fit" v-if="detail.id && status === 1 && !isDetail">
      <div class="bottom">
        <div class="left" style="margin-left:20px">已购买</div>
        <div class="right">
          <div class="btn" @click="goPickActivity()">
            马上学习
          </div>
        </div>
      </div>
    </div>

    <!-- 去支付弹框 -->
    <div v-if="payShow">
      <div class="popup_mengceng" @click="payShow = false"></div>

      <div class="popup-content" @click="payShow = true">
        <div class="top">
          <div style="width: 50%;text-align: center;">
            <div class="p-t-top" style="color: red !important;">仅剩{{ textNum }}名</div>
            <div class="p-t-bottom">剩余购课名额</div>
          </div>
          <div style="width: 50%;text-align: center;">
            <div class="p-t-top">
              <div class="width70px">{{ minutes }}</div>
              <div>:</div>
              <div class="width70px">{{ seconds }}</div>
              <div>:</div>
              <div class="width70px">{{ millisecond }}</div>
            </div>
            <div class="p-t-bottom">剩余支付时间</div>
          </div>
        </div>
        <div class="center">
          <div class="title">
            <div><img :src="arrow" class="arrow" /></div>
            <div>您的手机号（确认购买的<span>唯一凭证</span>）</div>
          </div>

          <div><input clearable v-model="form.phone" class="phone" placeholder="请输入手机号" type="tel" maxlength="11"
              :rules="rules" @focus="onFocus"></div>
          <div style="position: relative;">
            <input clearable v-model="form.sms" type="tel" class="sms" placeholder="请输入验证码" maxlength="6" :rules="rules"
              @focus="onFocus">
            <div slot="button" class="code-text" @click="getCode">{{ msg }}</div>
          </div>
        </div>
        <div class="footer-fit">
          <div class="bottom">
          <div class="left">限时仅需：￥<span class="left-qian">{{ detail.price }}</span></div>
          <div class="right">
            <div class="btn" @click.stop="getAddOrder()">
              <div class="grab">前200名限时抢购</div>
              <div class="enroll">马上报名</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
var that;
import { checkStr } from '@/utils/validate'
import { Toast } from 'vant';
export default {
  name: 'index_two',
  components: {},
  props: {},
  data() {
    return {
      isDetail: true,
      detail: {
        price: 0,
        detail: ''
      },
      token: '',
      payShow: false,
      status: '',
      arrow: require('@/assets/arrow1.png'),
      form: {
        phone: '',
        sms: ''
      },
      rules: [
        {
          required: true,
          message: '请输入手机号'
        },
        {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号'
        }
      ],
      msg: '获取验证码',
      isSend: false,


      minutes: '00',
      seconds: '00',
      millisecond: '00',
      intervalId: null,
      interval_miao: null,
      textNum: 28,
      countNum: 60,
      intervalCountNum: null,

    }
  },
  computed: {},
  watch: {},
  created() {
    that = this
    that.id = this.$route.query.channel_id;
    that.tid = this.$route.query.tid || -1;
    that.token = localStorage.getItem('token') || '';
    localStorage.removeItem('countdownTime')
    this.getDetail()

    //有code去登录
    const queryObj = this.getQueryObj()
    if (queryObj['code']) {
      this.getLogin()
    }
    this.token && this.getOrderDetail()
  },
  methods: {

    //下单去支付
    getAddOrder() {
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!checkStr(this.form.phone, 'mobile')) {
        this.$toast('请输入正确手机号')
        return
      }
      if (!this.form.sms) {
        this.$toast('请输入验证码')
        return
      }

      //判断验证码是否正确后再下单 
      this.$http.post('/app/users/verifyPhone', {
        phone: that.form.phone,
        smsCode: that.form.sms
      }).then(res => {
        that.addOrder();//去下单
      }).catch(err => {
        that.$toast(err.msg)
      })
    },

    async getCode() {
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!checkStr(this.form.phone, 'mobile')) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (this.isSend) return
      this.$http
        .post('/u/ali/sms', {
          phone: this.form.phone
        })
        .then(res => {
          this.$toast('验证码发送成功')
          let count = 60
          this.isSend = true
          this.msg = count + 's'
          this.timer = setInterval(() => {
            if (count === 1) {
              this.isSend = false
              this.msg = '发送验证码'

              clearInterval(this.timer)
              return
            }
            count--
            this.msg = count + 's'
          }, 1000)
        })
    },

    //拿到code去登录
    getLogin() {
      that.token = localStorage.getItem('token') || '';
      if (that.token != '') {
        return
      }
      const queryObj = this.getQueryObj()
      this.$http.get('/u/app/login/mpLogin', {
        code: queryObj['code'],
        tid: that.tid,
        channelId: this.id
      }).then(res => {
        console.log("token", res.data)
        localStorage.setItem('token', res.data)

        this.handleEnroll();
      }).catch(err => {
        //登录失效，清除token
        that.$toast('登录已失效,请退出再试')
        localStorage.removeItem('token')
        that.token = "";
      })
    },

    onFocus(e) {
      console.log(e)
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }, 400);
    },

    addOrder() {
      this.$http.post('/app/orders/addByChannel', {
        orderSource: this.detail.channelName,
        courseId: that.detail.courseId,
        channelId: that.id,
        phone: that.form.phone
      }).then(res => {
        this.payShow = false;
        this.$toast('正在下单')
        this.orderId = res.data;
        setTimeout(() => {
          that.goOrderPay()
        }, 1000);
      })
    },

    // 设置倒计时间隔和初始更新
    getDownTime() {
      that.clearTimer()
      that.countdownTime = localStorage.getItem('countdownTime') || (new Date().getTime() + 2 * 60 * 1000);
      if (that.countdownTime == 'undefined' || that.countdownTime == null) {
        that.countdownTime = (new Date().getTime() + 2 * 60 * 1000);
      }
      that.intervalId = setInterval(() => {
        that.updateCountdown(that.countdownTime)
      }, 200)
      that.millisecond = 99
      that.interval_miao = setInterval(() => {
        that.millisecond--
        if (that.millisecond < 10) {
          that.millisecond = '0' + that.millisecond
        }
        if (that.millisecond <= 0) {
          that.millisecond = 99
        }
      }, 10)
    },

    async getDetail() {
      const res = await this.$http.get('/app/channels/getInfo', {
        id: this.id
      })
      console.log(res)
      if (res.code == 200) {
        this.detail = res.data;
        this.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
        document.title = res.data.title;
        setTimeout(() => {
          this.isDetail = false;
        }, 500);
      } else {
        setTimeout(() => {
          this.isDetail = false;
          Toast('网络出现问题，请刷新重试!');
        }, 3000);
      }
    },
        
		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

    getQueryObj() {
      var query = location.search
      var queryObj = {}
      var arr = query.slice(1, query.length).split('&')
      arr.forEach(function (val) {
        var arr1 = val.split('=')
        queryObj[arr1[0]] = arr1[1]
      })

      return queryObj
    },

    getOrderDetail(isPay = false) {
      this.$http.get('/app/channels/getOrder', {
        id: this.id
      }).then(res => {
        if (res.code == 401) {
          localStorage.removeItem('token');
          this.token = '';
          this.$toast('登录已失效，请重新登录')
          return
        }

        if (!res.data) {
          if (isPay) {
            this.handleCardShow()
            this.getDownTime()
            this.payShow = true;
          }
          return
        }
        this.orderId = res.data.id
        this.status = res.data.status

        // 状态(-1已取消0待付款1已付款)
        if (res.data.status === 1) {
					this.getAgainCourse()
          if (isPay) {
            setTimeout(() => {
              this.goPickActivity()
            }, 500);
          }
        }
        // 状态(-1已取消0待付款1已付款)
        if (res.data.status === 0) {
          if (isPay) {
            this.goOrderPay()
          } else {
            //跳转待支付页 
            // this.$router.push({
            //   path: '/vxPublic/orderPay',
            //   query: { id: this.id }//这里不传订单id，默认不拉起支付
            // })
          }
        }
      })
    },

    // 获取授权后下单或直接下单
    handleEnroll() {
      // 课程详情用户已购买直接跳转二维码页面
      if (this.detail.purchased) {
        this.to_link()
        return
      }
      this.token = localStorage.getItem('token') || '';
      if (this.token == '') {
        console.log('获取vx授权code')
        window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
      } else {
        this.getOrderDetail(true);
      }
    },

    clearTimer() {
      clearInterval(this.intervalId)
      this.intervalId = null
      clearInterval(this.interval_miao);
      this.interval_miao = null;
      this.millisecond = '00';
    },

    updateCountdown(endTime) {
      const now = new Date().getTime()
      const distance = endTime - now

      if (distance < 0) {
        this.minutes = '00'
        this.seconds = '00'
        this.clearTimer()
        localStorage.removeItem('countdownTime')
        return
      }

      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + ''
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000) + ''
      this.minutes = this.minutes.length < 2 ? '0' + this.minutes : this.minutes
      this.seconds = this.seconds.length < 2 ? '0' + this.seconds : this.seconds
      localStorage.setItem('countdownTime', endTime)
    },

    handleCardShow() {
      clearInterval(this.intervalCountNum)
      this.intervalCountNum = setInterval(() => {
        console.log(this.countNum)
        //倒计时渐渐减少人数
        if (this.textNum > 1) {
          if (this.countNum == 58) {
            this.textNum = 26;
          } else if (this.countNum == 54) {
            this.textNum = 25;
          } else if (this.countNum == 52) {
            this.textNum = 20;
          } else if (this.countNum == 50) {
            this.textNum = 16;
          } else if (this.countNum == 46) {
            this.textNum = 12;
          } else if (this.countNum == 40) {
            this.textNum = 8;
          } else if (this.countNum == 35) {
            this.textNum = 5;
          } else if (this.countNum == 30) {
            this.textNum = 3;
          } else if (this.countNum == 28) {
            this.textNum = 2;
          } else if (this.countNum == 25) {
            this.textNum = 1;
          }
        }
        // 如果倒计时结束，停止倒计时
        if (this.countNum <= 0) {
          clearInterval(this.intervalCountNum)
        } else {
          // 每秒减少一秒
          this.countNum--;
        }
      }, 1000);
    },

    goPickActivity() {
      this.$router.push({
        path: '/vxPublic/successTwo',
        query: { orderId: this.orderId }
      })
    },

    goOrderPay() {
      this.$router.push({
        path: '/vxPublic/orderPay',
        query: { id: this.id, orderId: this.orderId, pagesType: 'three' }
      })
    }

  }
}
</script>

<style scoped lang="less">
.popup_mengceng {
  z-index: 2001;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
}


@keyframes van-fade-out {
  0% {
    opacity: 1
  }

  to {
    opacity: 0
  }
}

.danmu {
  position: fixed;
  top: 20vh;
  left: 5vw;
  padding: 10px 20px;
  background: #00000075;
  color: #fff;
  font-size: 24px;
  border-radius: 50px;
}

.fade-in {
  animation: slide-up-fade-in 0.5s forwards;
}

@keyframes slide-up-fade-in {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.fade-out {
  animation: slide-up-fade-out 2s forwards;
}

@keyframes slide-up-fade-out {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-30px);
    opacity: 0;
  }
}

.content img {
  pointer-events: none;
  cursor: default;
}

.loading {
  margin: 40vh auto;
  text-align: center;

  .loading-text {
    color: #39CCCD;
    font-weight: bold;
  }
}

.container {
  color: #333;
  font-size: 28px;
  // height: 100vh !important;
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    position: relative;
    // padding-bottom: 140px;
    // height: 100vh !important; 
    overflow-y: auto;

    ::v-deep img {
      display: block;
      width: 100% !important;
    }
  }
}

.header-bg {
  width: 100vw;
}

.footer-fit {
  flex-shrink: 0;
  // position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 2;
  // background-color: rgb(255, 250, 240);
  background-color: #ffffff;

  .bottom {
    padding: 20px 30px 30px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ff2400;
  }

  .left {
    // color: rgb(255, 36, 0);
    color: #ffffff;
    font-size: 42px;
    line-height: 40px;
    // font-weight: 600;

    .left-qian {
      font-size: 45px;
      font-family: sans-serif;
    }
  }

  .right {
    position: relative;

    .finger {
      width: 100px;
      height: 100px;
      position: absolute;

      left: -60px;
      top: 50%;
      margin-top: -50px;

      z-index: 1;
      -webkit-animation: fadefinger 0.4s ease infinite alternate;
      animation: fadefinger 0.4s ease infinite alternate;
    }

    @keyframes identifier {
      0% {
        transform: scale(.95);
      }

      50% {
        transform: scale(1.02);
      }

      100% {
        transform: scale(.95);
      }
    }

    .btn {
      background-color: #ffffff;
      color: #ff2400;
      width: 300px;
      height: 100px;
      line-height: 100px;
      border-radius: 50px;
      text-align: center;
      animation: identifier .7s linear infinite;
      font-size: 44px;

      .grab {
        font-size: 22px;
        line-height: 22px;
        margin-bottom: 10px;
        padding-top: 10px;
        font-weight: normal;
      }

      .enroll {
        // line-height: 44px;
        line-height: 40px;
        font-weight: bold;
        font-size: 44px;
      }
    }
  }
}

@keyframes fadefinger {
  0% {
    transform: translateX(35px);
    -webkit-transform: translateX(35px);
  }

  100% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }
}

@keyframes updown {
  0% {
    transform: translateY(8px);
    -webkit-transform: translateY(8px);
  }

  100% {
    transform: translateY(-8px);
    -webkit-transform: translateY(-8px);
  }
}

.popup-content {
  width: 100%;
  background: #fff;
  color: #333;
  bottom: 0;
  left: 0;
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 50px 50px 0 0;
  z-index: 2002 !important;

  .top {
    padding: 40px 30px 100px 30px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 20px 0 60px 0;
    padding: 20px 0;

    .p-t-top {
      font-size: 48px;
      font-weight: 600;
      color: #fa5925;
      // color: #ff6933;
      font-family: PingFangSC-Medium;
      display: flex;
      align-items: center;
      justify-content: center;

      .width70px {
				width: 70px;
			}
    }

    .p-t-bottom {
      margin-top: 10px;
      font-size: 32px;
      color: #f57347;
    }
  }


  .center {
    padding: 0px 30px 100px 30px;

    .title {
      font-size: 34px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        color: #ff5233;
        font-weight: 700;
      }

      .arrow {
        width: 60px;
        height: 60px;
        animation: updown 0.4s ease infinite alternate;
      }
    }

    .phone {
      width: 92%;
      background: #f5f5f5;
      border-radius: 20px;
      margin-top: 20px;
      font-size: 32px;
      padding: 27px;
      border: none !important;
    }

    .sms {
      margin-top: 20px;
      width: 690px;
      background: #f5f5f5;
      border-radius: 20px;
      width: 92%;
      font-size: 32px;
      padding: 27px;
      border: none !important;
    }

    .code-text {
      // color: rgb(255, 36, 0);
      font-size: 32px;
      position: absolute;
      top: 24px;
      right: 27px;
      bottom: 0;
      display: flex;
      align-items: center;
      color: #f57347;
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ff2400;
    padding: 15px 30px 30px 30px;

    .left {
      color: #fff;
      // font-size: 80px;
      line-height: 80px;

      display: flex;
      -webkit-box-align: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-shrink: 0;
      position: relative;

      .unit {
        font-size: 30px;
        line-height: 30px;
        position: absolute;
        left: 0;
        top: 25px;
        display: inline-block;
        font-family: PingFangSC-Medium;
      }

      .price {
        padding: 18px;
        font-weight: 700;
        font-family: PingFangSC-Medium;
      }

    }

    .right {
      color: #ff790d;
      background: rgb(255, 255, 255);
      width: 300px;
      height: 100px;
      line-height: 100px;
      border-radius: 50px;
      text-align: center;
      font-weight: 700;
      font-size: 50px;

      .grab {
        font-size: 22px;
        line-height: 22px;
        margin-bottom: 10px;
        padding-top: 10px;
        font-weight: normal;
      }

      .enroll {
        // line-height: 44px;
        line-height: 40px;
        font-weight: bold;
        font-size: 44px;
      }
    }
  }
}

.van-popup {
  background: #f4f4f4;
}

.active {
  border: 4px solid #ff6d00 !important;
}
</style>